import React from 'react';

import { Tr, Th } from '@/components/elements/Table'

const data = [
  { company: '岩井コスモ証券株式会社', analyst: '饗場　大介' },
  { company: 'SMBC日興証券株式会社', analyst: '松尾　賢弥' },
  { company: '株式会社SBI証券', analyst: '佐々木　俊' },
  { company: 'JPモルガン証券株式会社', analyst: '村田　大郎' },
  { company: 'シティグループ証券株式会社', analyst: '渡邉　宏樹' },
  { company: '大和証券株式会社', analyst: '重岡　絵美里' },
  { company: '野村證券株式会社', analyst: '坂本　雄右' },
  { company: 'BofA証券株式会社', analyst: '西澤　嵐' },
  { company: 'フィリップ証券株式会社', analyst: '田中　俊' },
  { company: '丸三証券株式会社', analyst: '長松　律喜' },
  { company: 'みずほ証券株式会社', analyst: '朝枝　英也' },
  { company: 'モルガン・スタンレーMUFG証券株式会社', analyst: '古川　藍' },
  // 他のデータをここに追加
  // 企業名で五十音順並びかえにする
];

export const ACTable = () => {
  return (
    <>
      {data.map((row, index) => (
        <Tr key={index} >
          <Th className="AnalystCoverage" color={'quaternary'} textAlign="left" >{row.company}</Th>
          <Th color={'quaternary'} textAlign="left">{row.analyst}</Th>
        </Tr>
      ))}
    </>
  );
}
